import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {OverlayModule} from '../overlay/index';
import {L10nModule} from '../translate';
import {AlertModalComponent} from './alert-modal';
import {ConfirmModalComponent} from './confirm-modal';
import {ModalAnchorComponent} from './modal-anchor.component';
import {ModalService} from './modal.service';

@NgModule({
    imports: [
        CommonModule,
        L10nModule,
        OverlayModule
    ],
    declarations: [
        ModalAnchorComponent,
        AlertModalComponent,
        ConfirmModalComponent
    ],
    exports: [
        ModalAnchorComponent
    ],
    providers: [
        ModalService
    ]
})
export class ModalModule {}
